import { TenantEntity } from '../TenantEntity'
import { getManifestGoods, getManifestVGMs, generateCfmManifestURL, generateShareCfmManifestURL, modifyManifestState,
  saveManifestRelatedInfo, sendCfmManifestEmail, sendShareCfmManifestEmail, getManifestInfo } from '@/api/seaExport/manifestInfo'

export class ManifestInfo extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'ManifestInfo'
  }
  get shipperShortCode() {
    return this._data.shipperShortCode
  }
  set shipperShortCode(shipperShortCode) {
    this._data.shipperShortCode = shipperShortCode
  }
  get shipperEnterpriseCode() {
    return this._data.shipperEnterpriseCode
  }
  set shipperEnterpriseCode(shipperEnterpriseCode) {
    this._data.shipperEnterpriseCode = shipperEnterpriseCode
  }
  get shipperEnterpriseName() {
    return this._data.shipperEnterpriseName
  }
  set shipperEnterpriseName(shipperEnterpriseName) {
    this._data.shipperEnterpriseName = shipperEnterpriseName
  }
  get shipperAddress() {
    return this._data.shipperAddress
  }
  set shipperAddress(shipperAddress) {
    this._data.shipperAddress = shipperAddress
  }
  get shipperContactsType() {
    return this._data.shipperContactsType
  }
  set shipperContactsType(shipperContactsType) {
    this._data.shipperContactsType = shipperContactsType || 0
  }
  get shipperContacts() {
    return this._data.shipperContacts
  }
  set shipperContacts(shipperContacts) {
    this._data.shipperContacts = shipperContacts
  }
  get shipperCityName() {
    return this._data.shipperCityName
  }
  set shipperCityName(shipperCityName) {
    this._data.shipperCityName = shipperCityName
  }
  get shipperProvinceCode() {
    return this._data.shipperProvinceCode
  }
  set shipperProvinceCode(shipperProvinceCode) {
    this._data.shipperProvinceCode = shipperProvinceCode
  }
  get shipperProvinceName() {
    return this._data.shipperProvinceName
  }
  set shipperProvinceName(shipperProvinceName) {
    this._data.shipperProvinceName = shipperProvinceName
  }
  get shipperZipCode() {
    return this._data.shipperZipCode
  }
  set shipperZipCode(shipperZipCode) {
    this._data.shipperZipCode = shipperZipCode
  }
  get shipperCountryCode() {
    return this._data.shipperCountryCode
  }
  set shipperCountryCode(shipperCountryCode) {
    this._data.shipperCountryCode = shipperCountryCode
  }
  get shipperAeoEnterpriseCode() {
    return this._data.shipperAeoEnterpriseCode
  }
  set shipperAeoEnterpriseCode(shipperAeoEnterpriseCode) {
    this._data.shipperAeoEnterpriseCode = shipperAeoEnterpriseCode
  }
  get consigneeShortCode() {
    return this._data.consigneeShortCode
  }
  set consigneeShortCode(consigneeShortCode) {
    this._data.consigneeShortCode = consigneeShortCode
  }
  get consigneeEnterpriseCode() {
    return this._data.consigneeEnterpriseCode
  }
  set consigneeEnterpriseCode(consigneeEnterpriseCode) {
    this._data.consigneeEnterpriseCode = consigneeEnterpriseCode
  }
  get consigneeEnterpriseName() {
    return this._data.consigneeEnterpriseName
  }
  set consigneeEnterpriseName(consigneeEnterpriseName) {
    this._data.consigneeEnterpriseName = consigneeEnterpriseName
  }
  get consigneeAddress() {
    return this._data.consigneeAddress
  }
  set consigneeAddress(consigneeAddress) {
    this._data.consigneeAddress = consigneeAddress
  }
  get consigneeContactsType() {
    return this._data.consigneeContactsType
  }
  set consigneeContactsType(consigneeContactsType) {
    this._data.consigneeContactsType = consigneeContactsType || 0
  }
  get consigneeContacts() {
    return this._data.consigneeContacts
  }
  set consigneeContacts(consigneeContacts) {
    this._data.consigneeContacts = consigneeContacts
  }
  get consigneeCityName() {
    return this._data.consigneeCityName
  }
  set consigneeCityName(consigneeCityName) {
    this._data.consigneeCityName = consigneeCityName
  }
  get consigneeProvinceCode() {
    return this._data.consigneeProvinceCode
  }
  set consigneeProvinceCode(consigneeProvinceCode) {
    this._data.consigneeProvinceCode = consigneeProvinceCode
  }
  get consigneeProvinceName() {
    return this._data.consigneeProvinceName
  }
  set consigneeProvinceName(consigneeProvinceName) {
    this._data.consigneeProvinceName = consigneeProvinceName
  }
  get consigneeZipCode() {
    return this._data.consigneeZipCode
  }
  set consigneeZipCode(consigneeZipCode) {
    this._data.consigneeZipCode = consigneeZipCode
  }
  get consigneeCountryCode() {
    return this._data.consigneeCountryCode
  }
  set consigneeCountryCode(consigneeCountryCode) {
    this._data.consigneeCountryCode = consigneeCountryCode
  }
  get consigneeAeoEnterpriseCode() {
    return this._data.consigneeAeoEnterpriseCode
  }
  set consigneeAeoEnterpriseCode(consigneeAeoEnterpriseCode) {
    this._data.consigneeAeoEnterpriseCode = consigneeAeoEnterpriseCode
  }
  get consigneeSpecificContactsName() {
    return this._data.consigneeSpecificContactsName
  }
  set consigneeSpecificContactsName(consigneeSpecificContactsName) {
    this._data.consigneeSpecificContactsName = consigneeSpecificContactsName
  }
  get consigneeSpecificContactsType() {
    return this._data.consigneeSpecificContactsType
  }
  set consigneeSpecificContactsType(consigneeSpecificContactsType) {
    this._data.consigneeSpecificContactsType = consigneeSpecificContactsType || 0
  }
  get consigneeSpecificContacts() {
    return this._data.consigneeSpecificContacts
  }
  set consigneeSpecificContacts(consigneeSpecificContacts) {
    this._data.consigneeSpecificContacts = consigneeSpecificContacts
  }
  get notifyShortCode() {
    return this._data.notifyShortCode
  }
  set notifyShortCode(notifyShortCode) {
    this._data.notifyShortCode = notifyShortCode
  }
  get notifyEnterpriseCode() {
    return this._data.notifyEnterpriseCode
  }
  set notifyEnterpriseCode(notifyEnterpriseCode) {
    this._data.notifyEnterpriseCode = notifyEnterpriseCode
  }
  get notifyEnterpriseName() {
    return this._data.notifyEnterpriseName
  }
  set notifyEnterpriseName(notifyEnterpriseName) {
    this._data.notifyEnterpriseName = notifyEnterpriseName
  }
  get notifyAddress() {
    return this._data.notifyAddress
  }
  set notifyAddress(notifyAddress) {
    this._data.notifyAddress = notifyAddress
  }
  get notifyContactsType() {
    return this._data.notifyContactsType
  }
  set notifyContactsType(notifyContactsType) {
    this._data.notifyContactsType = notifyContactsType || 0
  }
  get notifyContacts() {
    return this._data.notifyContacts
  }
  set notifyContacts(notifyContacts) {
    this._data.notifyContacts = notifyContacts
  }
  get notifyCityName() {
    return this._data.notifyCityName
  }
  set notifyCityName(notifyCityName) {
    this._data.notifyCityName = notifyCityName
  }
  get notifyProvinceCode() {
    return this._data.notifyProvinceCode
  }
  set notifyProvinceCode(notifyProvinceCode) {
    this._data.notifyProvinceCode = notifyProvinceCode
  }
  get notifyProvinceName() {
    return this._data.notifyProvinceName
  }
  set notifyProvinceName(notifyProvinceName) {
    this._data.notifyProvinceName = notifyProvinceName
  }
  get notifyZipCode() {
    return this._data.notifyZipCode
  }
  set notifyZipCode(notifyZipCode) {
    this._data.notifyZipCode = notifyZipCode
  }
  get notifyCountryCode() {
    return this._data.notifyCountryCode
  }
  set notifyCountryCode(notifyCountryCode) {
    this._data.notifyCountryCode = notifyCountryCode
  }
  get notifyAeoEnterpriseCode() {
    return this._data.notifyAeoEnterpriseCode
  }
  set notifyAeoEnterpriseCode(notifyAeoEnterpriseCode) {
    this._data.notifyAeoEnterpriseCode = notifyAeoEnterpriseCode
  }
  get instructBill() {
    return this._data.instructBill
  }
  set instructBill(instructBill) {
    this._data.instructBill = instructBill
  }
  get cfmState() {
    return this._data.cfmState
  }
  set cfmState(cfmState) {
    this._data.cfmState = cfmState || 0
  }
  get soNo() {
    return this._data.soNo
  }
  set soNo(soNo) {
    this._data.soNo = soNo
  }
  get shipperId() {
    return this._data.shipperId
  }
  set shipperId(shipperId) {
    this._data.shipperId = shipperId || 0
  }
  get consigneeId() {
    return this._data.consigneeId
  }
  set consigneeId(consigneeId) {
    this._data.consigneeId = consigneeId || 0
  }
  get notifyId() {
    return this._data.notifyId
  }
  set notifyId(notifyId) {
    this._data.notifyId = notifyId || 0
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get manifestVGMs() {
    return this._data.manifestVGMs
  }
  set manifestVGMs(manifestVGMs) {
    this._data.manifestVGMs = manifestVGMs
  }
  get manifestGoods() {
    return this._data.manifestGoods
  }
  set manifestGoods(manifestGoods) {
    this._data.manifestGoods = manifestGoods
  }
  // 下载模版相关代码撤回
  get freeDemurrage() {
    return this._data.freeDemurrage
  }
  set freeDemurrage(freeDemurrage) {
    this._data.freeDemurrage = freeDemurrage
  }
  get freeDetention() {
    return this._data.freeDetention
  }
  set freeDetention(freeDetention) {
    this._data.freeDetention = freeDetention
  }
  get remark() {
    return this._data.remark
  }
  set remark(remark) {
    this._data.remark = remark
  }
  get customsAreaApplication() {
    return this._data.customsAreaApplication
  }
  set customsAreaApplication(customsAreaApplication) {
    this._data.customsAreaApplication = customsAreaApplication
  }
  get surchargeTerms() {
    return this._data.surchargeTerms
  }
  set surchargeTerms(surchargeTerms) {
    this._data.surchargeTerms = surchargeTerms
  }

  // 海管家新增字段
  get mblNo() {
    return this._data.mblNo
  }
  set mblNo(mblNo) {
    this._data.mblNo = mblNo
  }
  get bargeVessel() {
    return this._data.bargeVessel
  }
  set bargeVessel(bargeVessel) {
    this._data.bargeVessel = bargeVessel
  }
  get bargeVoyage() {
    return this._data.bargeVoyage
  }
  set bargeVoyage(bargeVoyage) {
    this._data.bargeVoyage = bargeVoyage
  }
  get shippingCompany() {
    return this._data.shippingCompany
  }
  set shippingCompany(shippingCompany) {
    this._data.shippingCompany = shippingCompany
  }
  get carrierAgent() {
    return this._data.carrierAgent
  }
  set carrierAgent(carrierAgent) {
    this._data.carrierAgent = carrierAgent
  }
  get portOfLoading() {
    return this._data.portOfLoading
  }
  set portOfLoading(portOfLoading) {
    this._data.portOfLoading = portOfLoading
  }
  get portOfDischarge() {
    return this._data.portOfDischarge
  }
  set portOfDischarge(portOfDischarge) {
    this._data.portOfDischarge = portOfDischarge
  }
  get portOfDestination() {
    return this._data.portOfDestination
  }
  set portOfDestination(portOfDestination) {
    this._data.portOfDestination = portOfDestination
  }
  get cargoType() {
    return this._data.cargoType
  }
  set cargoType(cargoType) {
    this._data.cargoType = cargoType
  }
  get masterBLFreightTermTootip() {
    return this._data.masterBLFreightTermTootip
  }
  set masterBLFreightTermTootip(masterBLFreightTermTootip) {
    this._data.masterBLFreightTermTootip = masterBLFreightTermTootip
  }
  get masterBLFreightTerm() {
    return this._data.masterBLFreightTerm
  }
  set masterBLFreightTerm(masterBLFreightTerm) {
    this._data.masterBLFreightTerm = masterBLFreightTerm
  }
  get blType() {
    return this._data.blType
  }
  set blType(blType) {
    this._data.blType = blType
  }
  get placeOfPayment() {
    return this._data.placeOfPayment
  }
  set placeOfPayment(placeOfPayment) {
    this._data.placeOfPayment = placeOfPayment
  }
  get blNumber() {
    return this._data.blNumber
  }
  set blNumber(blNumber) {
    this._data.blNumber = blNumber
  }
  get sailingDate() {
    return this._data.sailingDate
  }
  set sailingDate(sailingDate) {
    this._data.sailingDate = sailingDate
  }
  get signPlaceBL() {
    return this._data.signPlaceBL
  }
  set signPlaceBL(signPlaceBL) {
    this._data.signPlaceBL = signPlaceBL
  }
  get signDateBL() {
    return this._data.signDateBL
  }
  set signDateBL(signDateBL) {
    this._data.signDateBL = signDateBL
  }
  get dispatchingPlaceCode() {
    return this._data.dispatchingPlaceCode
  }
  set dispatchingPlaceCode(dispatchingPlaceCode) {
    this._data.dispatchingPlaceCode = dispatchingPlaceCode
  }
  get channel() {
    return this._data.channel
  }
  set channel(channel) {
    this._data.channel = channel
  }
  get manifestId() {
    return this._data.manifestId
  }
  set manifestId(manifestId) {
    this._data.manifestId = manifestId
  }
  get thirdPartyCarrier() {
    return this._data.thirdPartyCarrier
  }
  set thirdPartyCarrier(thirdPartyCarrier) {
    this._data.thirdPartyCarrier = thirdPartyCarrier
  }
  get thirdPartyCarrierAgent() {
    return this._data.thirdPartyCarrierAgent
  }
  set thirdPartyCarrierAgent(thirdPartyCarrierAgent) {
    this._data.thirdPartyCarrierAgent = thirdPartyCarrierAgent
  }
  get thirdPartyFreightTerm() {
    return this._data.thirdPartyFreightTerm
  }
  set thirdPartyFreightTerm(thirdPartyFreightTerm) {
    this._data.thirdPartyFreightTerm = thirdPartyFreightTerm
  }
  get thirdPartyPaymentMethod() {
    return this._data.thirdPartyPaymentMethod
  }
  set thirdPartyPaymentMethod(thirdPartyPaymentMethod) {
    this._data.thirdPartyPaymentMethod = thirdPartyPaymentMethod
  }
  get thirdPartyCargoType() {
    return this._data.thirdPartyCargoType
  }
  set thirdPartyCargoType(thirdPartyCargoType) {
    this._data.thirdPartyCargoType = thirdPartyCargoType
  }
  get thirdPartyBlType() {
    return this._data.thirdPartyBlType
  }
  set thirdPartyBlType(thirdPartyBlType) {
    this._data.thirdPartyBlType = thirdPartyBlType
  }
  get imo() {
    return this._data.imo
  }
  set imo(imo) {
    this._data.imo = imo
  }

  get importTempUuid() {
    return this._data.importTempUuid
  }
  set importTempUuid(importTempUuid) {
    this._data.importTempUuid = importTempUuid
  }

  static async saveManifestRelatedInfo(data) {
    return await saveManifestRelatedInfo(data).then(res => res.data)
  }
  static async sendShareCfmManifestEmail(emailAddress) {
    await sendShareCfmManifestEmail({ emailAddress })
  }
  async modifyCfmState(state) {
    return await modifyManifestState({ manifestInfoUuid: this._data.uuid, state }).then(res => res.data)
  }
  async getManifestGoods() {
    const data = this._data
    if (typeof data.manifestGoods !== 'object') {
      data.manifestGoods = await getManifestGoods({ manifestInfoUuid: data.uuid }).then(res => res.data)
    }
    return data.manifestGoods
  }
  async getManifestVGMs() {
    const data = this._data
    if (typeof data.manifestVGMs !== 'object') {
      data.manifestVGMs = await getManifestVGMs({ manifestInfoUuid: data.uuid }).then(res => res.data)
    }
    return data.manifestVGMs
  }
  async getCfmManifestUrl() {
    const data = this._data
    if (typeof data.cfmManifestUrl === 'undefined') {
      data.cfmManifestUrl = await generateCfmManifestURL({ jobUuid: data.jobUuid, manifestInfoUuid: data.uuid }).then(res => res.data)
    }
    return data.cfmManifestUrl
  }
  async getCfmManifestShareUrl() {
    const data = this._data
    if (typeof data.cfmManifestShareUrl === 'undefined') {
      data.cfmManifestShareUrl = await generateShareCfmManifestURL().then(res => res.data)
    }
    return data.cfmManifestShareUrl
  }
  async sendCfmManifestEmail(jobUuid, emailAddress) {
    await sendCfmManifestEmail(this._data, { jobUuid, emailAddress })
  }
  async reload() {
    await getManifestInfo({ uuid: this._data.uuid }).then(res => {
      if (res.data) {
        Object.assign(this._data, res.data)
      }
    })
  }
}
